import api from '@/utils/api';
import {
    ADD_DEVICE_TOKEN,
    FETCH_NOTIFICATIONS,
    MARK_READ_NOTIFICATIONS,
    MARK_ALL_READ_NOTIFICATIONS,
    SET_UNREAD_COUNT_NOTIFICATIONS,
    FETCH_NOTIFICATIONS_SUMMARY,
    MARK_NOTIFICATION_UNREAD
} from './types';
import { NotificationManager } from 'react-notifications';


/**
 * Lấy danh sách thông báo chi tiết (trang quản lý)
 * Route: GET /notifications/list
 */
export const fetchNotifications = (filter = {}) => dispatch => {
    return api.get('/notifications/list', { params: filter })
        .then(res => {
            const data = res.data?.data || {};
            const items = data.items?.data || [];
            const pagination = {
                currentPage: parseInt(data.items?.current_page) || 1,
                total: parseInt(data.items?.total) || 0,
                perPage: parseInt(data.items?.per_page) || 30,
            };
            const unreadCount = data.unread_count || 0;

            dispatch({
                type: FETCH_NOTIFICATIONS,
                payload: { items, pagination, unreadCount }
            });
            dispatch({ type: SET_UNREAD_COUNT_NOTIFICATIONS, payload: unreadCount });
            return res.data;
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Không tải được danh sách thông báo');
            throw err;
        });
};

/**
 * Lấy danh sách thông báo nhanh (hiển thị ở header)
 * Route: GET /notifications/summary
 */
export const fetchNotificationsSummary = (filter = {}) => dispatch => {
    return api.get('/notifications/summary', { params: filter })
        .then(res => {
            const data = res.data?.data || {};
            const items = data.items?.data || [];
            const pagination = {
                currentPage: parseInt(data.items?.current_page) || 1,
                total: parseInt(data.items?.total) || 0,
                perPage: parseInt(data.items?.per_page) || 30,
            };
            const unreadCount = data.unread_count || 0;

            dispatch({
                type: FETCH_NOTIFICATIONS_SUMMARY,
                payload: { items, pagination, unreadCount }
            });
            dispatch({ type: SET_UNREAD_COUNT_NOTIFICATIONS, payload: unreadCount });
            return res.data;
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Không tải được thông báo nhanh');
            throw err;
        });
};

export const markNotificationRead = (id) => dispatch => {
    return api.post(`/notifications/${id}/read`)
        .then(res => {
            dispatch({ type: MARK_READ_NOTIFICATIONS, payload: id });
            return res.data.data;
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Không đánh dấu đã đọc');
            throw err;
        });
};

export const markAllNotificationsRead = () => dispatch => {
    return api.post('/notifications/read-all')
        .then(() => {
            dispatch({ type: MARK_ALL_READ_NOTIFICATIONS });
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Không đánh dấu tất cả đã đọc');
            throw err;
        });
};

export const markNotificationUnread = (id) => async (dispatch) => {
    const res = await api.post(`/notifications/${id}/unread`);
    dispatch({
        type: MARK_NOTIFICATION_UNREAD,
        payload: { id },
    });
    return res;
};

export const addDeviceToken = (data) => dispatch => {
    return api.post('/notifications/add-device-token', data)
        .then(res => {
            dispatch({ type: ADD_DEVICE_TOKEN, payload: res.data.data });
            return res.data.data;
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Không thể thêm token');
            throw err;
        });
};


